import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api.service';
import { PartnerMailingRequest } from './partner';

@Injectable({ providedIn: 'root' })
export class CompanyProfileApiService {
  private updateUrl = `/api/v3/partner/updateMailingAddress/`;

  constructor(private apiService: ApiService) {}

  public updatePartnerMailingAddress(partner: PartnerMailingRequest): Observable<any> {
    return this.apiService.post(this.updateUrl, partner);
  }
}
